var React = require('react');

function Right (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M0 3L3.2608 0L16 12L3.2608 24L0 21L9.6 12L0 3Z","fill":"currentColor"}));
}

Right.defaultProps = {"viewBox":"0 0 16 24","fill":"currentColor"};

module.exports = Right;

Right.default = Right;
